const RELOAD_COUNT_KEY = "komut:chunk-reload-count";
const MAX_RELOADS = 2;
const CHUNK_ERROR_PATTERN =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|outdated optimize dep/i;

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "";
  return CHUNK_ERROR_PATTERN.test(message);
}

function reloadOnce(): void {
  try {
    const attempts = Number(sessionStorage.getItem(RELOAD_COUNT_KEY) ?? "0");
    if (attempts >= MAX_RELOADS) return;
    sessionStorage.setItem(RELOAD_COUNT_KEY, String(attempts + 1));
  } catch {
    return;
  }
  window.location.reload();
}

/**
 * Loads a dynamically imported module with no added latency on the happy path.
 *
 * A chunk-load failure means the requested chunk is gone (stale hash after a
 * deploy) or temporarily unavailable, which a retry cannot fix and a reload can.
 * Reloads at most twice per session to avoid loops; the error boundary handles
 * the case where even a reload does not recover.
 */
export function importOrReload<T>(factory: () => Promise<T>): Promise<T> {
  return factory().catch((error: unknown) => {
    if (isChunkLoadError(error)) reloadOnce();
    throw error;
  });
}
